/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    publishedStatusWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 32, // @TODO: add to all banners?
    },

    adminSettingsWrapper: {
      backgroundColor: colors.primaryExtraLight,
    },
    adminOptionsInner: {
      flex: 1,
    },
  };
};

export default getStyles;
